// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MAMode } from '../../IndicatorConstants';
import { ExpandDoubleVector } from '../../DoubleMatrix';
import { IndicatorFunctions } from '../../IndicatorFunctions';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iCCIEx = 'iCCIEx';
export class ICCIEx extends iBuildInIndicator {
    constructor(maPeriod, maType, priceType) {
        super(1);
        this.ma = new ExpandDoubleVector();
        this.FMaPeriod = maPeriod;
        this.FMaType = maType | MAMode.SMA;
        this.FPriceType = priceType;
    }
    get Name() {
        return iCCIEx;
    }
    get Key() {
        return this.DefaultKey + this.FMaPeriod + this.FMaType;
    }
    NextBar(callBound) {
        super.NextBar(callBound);
        this.ma.Add(0.0);
    }
    Refresh(count, newThread) {
        this.ma.Dispose();
        this.ma = new ExpandDoubleVector();
        super.Refresh(count, newThread);
    }
    OnQuote() {
        this.ma[this.ma.Length - 1] = this.GetPrice(this.FPriceType, 0);
        const Parent = this.Parent;
        if (!Parent || this.FCount < this.FMaPeriod || this.FMaPeriod === 0) {
            return;
        }
        let d = 0.0;
        const maValue = IndicatorFunctions.CallMovingFunction(this.FMaType, this.ma, this.FMaPeriod, 1);
        for (let i = 0; i < this.FMaPeriod; i++) {
            d += Math.abs(this.GetPrice(this.FPriceType, i) - maValue);
        }
        d = 0.015 * (d / this.FMaPeriod);
        if (d !== 0.0) {
            this.SetValue(0, 0, (this.GetPrice(this.FPriceType, 0) - maValue) / d);
        }
    }
}
